import React from 'react';

const UnknownProspect: React.FC<{ width?: number; height?: number }> = ({
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z"
      fill="#1E3A8A"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.4C10.8165 6.4 9.85714 7.3402 9.85714 8.5C9.85714 9.6598 10.8165 10.6 12 10.6C13.1835 10.6 14.1429 9.6598 14.1429 8.5C14.1429 7.3402 13.1835 6.4 12 6.4ZM8.42857 8.5C8.42857 6.567 10.0276 5 12 5C13.9724 5 15.5714 6.567 15.5714 8.5C15.5714 10.433 13.9724 12 12 12C10.0276 12 8.42857 10.433 8.42857 8.5Z"
      fill="#3B82F6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5714 14.8C10.0031 14.8 9.45806 15.0212 9.0562 15.4151C8.65434 15.8089 8.42857 16.343 8.42857 16.9V18.3C8.42857 18.6866 8.10877 19 7.71429 19C7.3198 19 7 18.6866 7 18.3V16.9C7 15.9717 7.37627 15.0815 8.04605 14.4251C8.71582 13.7687 9.62423 13.4 10.5714 13.4H13.4286C14.3758 13.4 15.2842 13.7687 15.954 14.4251C16.6237 15.0815 17 15.9717 17 16.9V18.3C17 18.6866 16.6802 19 16.2857 19C15.8912 19 15.5714 18.6866 15.5714 18.3V16.9C15.5714 16.343 15.3457 15.8089 14.9438 15.4151C14.5419 15.0212 13.9969 14.8 13.4286 14.8H10.5714Z"
      fill="#3B82F6"
    />
  </svg>
);

export default UnknownProspect;
